import { identifyRumUser, setRumCompany, trackMenuExposure } from '../../helpers/rum';

/**
 * Vuex plugin that keeps Datadog RUM's user and company in step with the store. Every login path
 * (password, PIN, SSO, auto-login, reload) ends in these mutations, so this is the one place
 * that covers them all.
 * @param {Object} store - Vuex store instance
 */
export default function rumPlugin(store) {
  store.subscribe(({ type, payload }) => {
    try {
      switch (type) {
        case 'SET_USER_DETAILS':
          identifyRumUser(payload);
          break;
        case 'SET_COMPANY_SETTINGS':
          setRumCompany(payload);
          break;
        case 'SET_MAIN_MENU':
          trackMenuExposure(payload, store.state.companySettings);
          break;
        default:
      }
    } catch (error) {
      // tracking must never break a commit
      console.warn('[rum]', error);
    }
  });
}
